import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {RequestsState} from "@portals/store";

@Component({
	selector: 'portals-click-scan',
	templateUrl: './click-scan.component.html',
	styleUrls: ['./click-scan.component.scss'],
})
export class ClickScanComponent {
    requestForm: FormGroup;
    emailSent = false;
    emailSending = false;
    errorMessage = '';

	constructor(private router: Router, private fb: FormBuilder, private requestsState: RequestsState) {
        this.requestForm = this.fb.group(
            {
                email: ['', [Validators.required, Validators.email]],
                name: ['', [Validators.required, Validators.pattern(/^[a-zA-Z\s]+$/)]],
                number: ['', [Validators.pattern(/^[\d()+-]+$/)]],
                organization: [''],
                message: ['', Validators.required],
                textConsent: [false],
            },
            { validators: this.textConsentValidator }
        );
    }


	goToSendMessage() {
	  this.router.navigate(['/send-message']);
	}

    textConsentValidator: ValidatorFn = (formGroup: AbstractControl) => {
        const numberControl = formGroup.get('number');
        const textConsentControl = formGroup.get('textConsent');

        if (numberControl && textConsentControl) {
            const number = numberControl.value;
            const textConsent = textConsentControl.value;

            if (number && !textConsent) {
                textConsentControl.setErrors({ required: true });
            } else {
                textConsentControl.setErrors(null);
            }
        }
        return null;
    };

    sendEmail() {
        if (this.requestForm.invalid) {
            this.errorMessage = 'Please fill out all required fields correctly before submitting.';
            this.requestForm.markAllAsTouched();

            // Scroll to the top of the form
            const formElement = document.querySelector('.inputWButton');
            if (formElement) {
                formElement.scrollIntoView({ behavior: 'smooth' });
            }

            return;
        }

        this.errorMessage = '';
        this.emailSending = true;

        // Retrieve all form values
        const formData = this.requestForm.value;

        // Prepare the data to send in the request
        const requestData = {
            data: {
                email: formData.email,
                name: formData.name,
                phone: formData.number,
                company: formData.organization,
                message: formData.message,
                context: 'Jotto_Contact',
            },
        };

        // Call the createRequest method with the prepared data
        this.createRequest(requestData);
    }


    createRequest(form: any) {
        this.requestsState.create(form).subscribe({
            next: (response) => {
                this.emailSent = true;
                this.emailSending = false;
                // Handle successful creation here
                console.log('Request created successfully', response);
            },
            error: (error) => {
                this.emailSending = false;
                this.errorMessage = 'An error occurred while sending the email.';
                // Handle error here
                console.error('Error creating request', error);
            }
        });
    }
}
